import Local from '@/common/util/local.js';

const BAD_BROWSER_CHECK = 'BAD_BROWSER_CHECK';

export function badBrowserLocalGet() {
    return Local.get(BAD_BROWSER_CHECK, false);
}

export function badBrowserLocalSet(value) {
    Local.put(BAD_BROWSER_CHECK, value);
}
